import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const paymentSlipRouter: Array<RouteRecordRaw> = [
  {
    path: '/paymentSlip',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      order: 4, // 导航栏权重
      title: 'paymentSlipManagement',
      icon: '#iconyijicaidan',
      roles: [
        'PAYMENT_PLAN_R', 'PAYMENT_PLAN_W',
        'PAYMENT_PLAN_REPORTS_R', 'PAYMENT_PLAN_REPORTS_W',
        'OUTSIDE_PAYMENT_PLAN_R', 'OUTSIDE_PAYMENT_PLAN_W',
        'PAYMENT_EXE_R', 'PAYMENT_EXE_W',
        'PAYMENT_HIS_R',
        'PAYMENT_TRAN_R'
      ]
    },
    children: [
      {
        path: 'planned',
        component: () => import(/* webpackChunkName: "PaymentSlipPageList" */ '@/views/pay/PaymentSlipPageList.vue'),
        name: 'PaymentSlipPageList',
        meta: {
          title: 'PlannedPaymentSlip',
          icon: '#iconerjicaidan',
          roles: ['PAYMENT_PLAN_R', 'PAYMENT_PLAN_W'],
          keepAlive: true
        }
      },
      {
        path: 'paymentSlipDetail',
        component: () => import(/* webpackChunkName: "ApprovalFormDetail" */ '@/views/pay/PaymentSlipDetail.vue'),
        name: 'PlannedPaymentSlipDetail',
        meta: {
          title: 'plannedPaymentSlipDetail',
          hidden: true,
          noCache: true,
          roles: ['PAYMENT_PLAN_W']
        }
      },
      {
        path: 'planned/reports',
        component: () => import(/* webpackChunkName: "PlannedPaymentReportsPageList" */ '@/views/pay/PlannedPaymentReportsPageList.vue'),
        name: 'PlannedPaymentReportsPageList',
        meta: {
          title: 'plannedPaymentSlipReports',
          icon: '#iconerjicaidan',
          roles: ['PAYMENT_PLAN_REPORTS_R', 'PAYMENT_PLAN_REPORTS_W'],
          keepAlive: true
        }
      },
      {
        path: 'outsidePayment',
        component: () => import(/* webpackChunkName: "PaymentSlipOutsidePageList" */ '@/views/pay/PaymentSlipOutsidePageList.vue'),
        name: 'PaymentSlipOutsidePageList',
        meta: {
          title: 'outsidePaymentSlip',
          icon: '#iconerjicaidan',
          roles: ['OUTSIDE_PAYMENT_PLAN_R', 'OUTSIDE_PAYMENT_PLAN_W'],
          keepAlive: true
        }
      },
      {
        path: 'execute',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/pay/PaymentSlipBufferPageList.vue'),
        name: 'PaymentSlipBufferPageList',
        meta: {
          title: 'pendingExecutionPaymentSlip',
          icon: '#iconerjicaidan',
          roles: ['PAYMENT_EXE_R', 'PAYMENT_EXE_W'],
          keepAlive: true
        }
      },
      {
        path: 'history',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/pay/PaymentSlipHistory.vue'),
        name: 'PaymentSlipHistoryList',
        meta: {
          title: 'paymentSlipHistory',
          icon: '#iconerjicaidan',
          roles: ['PAYMENT_HIS_R'],
          keepAlive: true
        }
      },
      {
        path: 'cashDetail/:id',
        component: () => import(/* webpackChunkName: "PaymentSlipHistoryCashDetail" */ '@/views/pay/PaymentSlipHistoryCashDetail.vue'),
        name: 'PaymentSlipHistoryCashDetail',
        meta: {
          title: 'paymentSlipHistoryCashDetail',
          hidden: true,
          noCache: true,
          roles: ['PAYMENT_HIS_R']
        }
      },
      {
        path: 'bufferDetail/:id/',
        component: () => import(/* webpackChunkName: "PaymentSlipBufferDetail" */ '@/views/pay/PaymentSlipBufferDetail.vue'),
        name: 'PaymentSlipBufferDetail',
        meta: {
          title: 'paymentSlipBufferDetailDetail',
          hidden: true,
          noCache: true,
          roles: ['PAYMENT_HIS_R']
        }
      },
      {
        path: 'acceptanceDetail/:id',
        component: () => import(/* webpackChunkName: "PaymentSlipHistoryCashDetail" */ '@/views/pay/PaymentSlipHistoryAcceptanceDetail.vue'),
        name: 'PaymentSlipHistoryAcceptanceDetail',
        meta: {
          title: 'paymentSlipHistoryAcceptanceDetail',
          hidden: true,
          noCache: true,
          roles: ['PAYMENT_HIS_R']
        }
      },
      {
        path: 'statement',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/pay/PaymentSlipStatement.vue'),
        name: 'PaymentSlipStatement',
        meta: {
          icon: '#iconerjicaidan',
          title: 'paymentStatement',
          roles: ['PAYMENT_TRAN_R'],
          keepAlive: true
        }
      }
    ]
  }
]
export default paymentSlipRouter
